import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const FooterEditor = () => {
  const [form, setForm] = useState({
    FollowUsEn: "", FollowUsAr: "", FollowUsKu: "",
    UsefulLinksTitleEn: "", UsefulLinksTitleAr: "", UsefulLinksTitleKu: "",
    Useful1En: "", Useful1Ar: "", Useful1Ku: "",
    Useful2En: "", Useful2Ar: "", Useful2Ku: "",
    Useful3En: "", Useful3Ar: "", Useful3Ku: "",
    TechTitleEn: "", TechTitleAr: "", TechTitleKu: "",
    Tech1En: "", Tech1Ar: "", Tech1Ku: "",
    Tech2En: "", Tech2Ar: "", Tech2Ku: "",
    WarrantyTitleEn: "", WarrantyTitleAr: "", WarrantyTitleKu: "",
    WarrantyBlock1Big: "", WarrantyBlock1Small: "",
    WarrantyBlock2Big: "", WarrantyBlock2Small: "",
    AboutEn: "", AboutAr: "", AboutKu: "",
    PrivacyEn: "", PrivacyAr: "", PrivacyKu: "",
    YearText: "", CompanyLogoPath: "",
    InstagramUrl: "", LinkedInUrl: "", FacebookUrl: "",
    YouTubeUrl: "", TikTokUrl: "",
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const en = (await axios.get(`${API_BASE}/api/FooterSection?lang=en`)).data;
        const ar = (await axios.get(`${API_BASE}/api/FooterSection?lang=ar`)).data;
        const ku = (await axios.get(`${API_BASE}/api/FooterSection?lang=ku`)).data;

        setForm({
          FollowUsEn: en.followUs, FollowUsAr: ar.followUs, FollowUsKu: ku.followUs,
          UsefulLinksTitleEn: en.usefulLinksTitle, UsefulLinksTitleAr: ar.usefulLinksTitle, UsefulLinksTitleKu: ku.usefulLinksTitle,
          Useful1En: en.useful1, Useful1Ar: ar.useful1, Useful1Ku: ku.useful1,
          Useful2En: en.useful2, Useful2Ar: ar.useful2, Useful2Ku: ku.useful2,
          Useful3En: en.useful3, Useful3Ar: ar.useful3, Useful3Ku: ku.useful3,
          TechTitleEn: en.techTitle, TechTitleAr: ar.techTitle, TechTitleKu: ku.techTitle,
          Tech1En: en.tech1, Tech1Ar: ar.tech1, Tech1Ku: ku.tech1,
          Tech2En: en.tech2, Tech2Ar: ar.tech2, Tech2Ku: ku.tech2,
          WarrantyTitleEn: en.warrantyTitle, WarrantyTitleAr: ar.warrantyTitle, WarrantyTitleKu: ku.warrantyTitle,
          WarrantyBlock1Big: en.block1Big, WarrantyBlock1Small: en.block1Small,
          WarrantyBlock2Big: en.block2Big, WarrantyBlock2Small: en.block2Small,
          AboutEn: en.about, AboutAr: ar.about, AboutKu: ku.about,
          PrivacyEn: en.privacy, PrivacyAr: ar.privacy, PrivacyKu: ku.privacy,
          YearText: en.year, CompanyLogoPath: en.logo,
          InstagramUrl: en.instagram,
          LinkedInUrl: en.linkedin,
          FacebookUrl: en.facebook,
          YouTubeUrl: en.youtube,
          TikTokUrl: en.tiktok,
        });

        setLoading(false);
      } catch (err) {
        console.error("Failed loading footer", err);
      }
    };
    load();
  }, []);

  const set = (e) => setForm({ ...form, [e.target.name]: e.target.value });

const update = async () => {
  try {
    const token = localStorage.getItem("token");

    await axios.put(
      `${API_BASE}/api/FooterSection/1`,
      form,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    alert("Footer updated successfully!");
  } catch (err) {
    alert("Update failed");
    console.error(err);
  }
};

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container py-4">

      <h2 className="mb-4 text-primary">Footer Editor</h2>

      {/* FOLLOW US */}
      <div className="card mb-4">
        <div className="card-header">Follow Us Text</div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <input name="FollowUsEn" className="form-control" value={form.FollowUsEn} onChange={set} placeholder="English" />
            </div>
            <div className="col-md-4">
              <input name="FollowUsAr" className="form-control" value={form.FollowUsAr} onChange={set} placeholder="Arabic" />
            </div>
            <div className="col-md-4">
              <input name="FollowUsKu" className="form-control" value={form.FollowUsKu} onChange={set} placeholder="Kurdish" />
            </div>
          </div>
        </div>
      </div>

      {/* USEFUL LINKS TITLE */}
      <div className="card mb-4">
        <div className="card-header">Useful Links Title</div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <input name="UsefulLinksTitleEn" className="form-control" value={form.UsefulLinksTitleEn} onChange={set} />
            </div>
            <div className="col-md-4">
              <input name="UsefulLinksTitleAr" className="form-control" value={form.UsefulLinksTitleAr} onChange={set} />
            </div>
            <div className="col-md-4">
              <input name="UsefulLinksTitleKu" className="form-control" value={form.UsefulLinksTitleKu} onChange={set} />
            </div>
          </div>
        </div>
      </div>

      {/* USEFUL LINKS BLOCKS */}
      {["1", "2", "3"].map((num) => (
        <div className="card mb-4" key={num}>
          <div className="card-header">Useful Link {num}</div>
          <div className="card-body">
            <div className="row g-3">
              <div className="col-md-4">
                <input name={`Useful${num}En`} className="form-control" value={form[`Useful${num}En`]} onChange={set} placeholder="English" />
              </div>
              <div className="col-md-4">
                <input name={`Useful${num}Ar`} className="form-control" value={form[`Useful${num}Ar`]} onChange={set} placeholder="Arabic" />
              </div>
              <div className="col-md-4">
                <input name={`Useful${num}Ku`} className="form-control" value={form[`Useful${num}Ku`]} onChange={set} placeholder="Kurdish" />
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* TECH SPECS */}
      <div className="card mb-4">
        <div className="card-header">Tech Specs Title</div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4"><input name="TechTitleEn" className="form-control" value={form.TechTitleEn} onChange={set} /></div>
            <div className="col-md-4"><input name="TechTitleAr" className="form-control" value={form.TechTitleAr} onChange={set} /></div>
            <div className="col-md-4"><input name="TechTitleKu" className="form-control" value={form.TechTitleKu} onChange={set} /></div>
          </div>
        </div>
      </div>

      {/* WARRANTY */}
      <div className="card mb-4">
        <div className="card-header">Warranty</div>
        <div className="card-body">
          <div className="row g-3 mb-3">
            <div className="col-md-4"><input name="WarrantyTitleEn" className="form-control" value={form.WarrantyTitleEn} onChange={set} /></div>
            <div className="col-md-4"><input name="WarrantyTitleAr" className="form-control" value={form.WarrantyTitleAr} onChange={set} /></div>
            <div className="col-md-4"><input name="WarrantyTitleKu" className="form-control" value={form.WarrantyTitleKu} onChange={set} /></div>
          </div>

          <h6>Warranty Blocks</h6>
          <div className="row g-3">
            <div className="col-md-3"><input name="WarrantyBlock1Big" className="form-control" value={form.WarrantyBlock1Big} onChange={set} /></div>
            <div className="col-md-3"><input name="WarrantyBlock1Small" className="form-control" value={form.WarrantyBlock1Small} onChange={set} /></div>
            <div className="col-md-3"><input name="WarrantyBlock2Big" className="form-control" value={form.WarrantyBlock2Big} onChange={set} /></div>
            <div className="col-md-3"><input name="WarrantyBlock2Small" className="form-control" value={form.WarrantyBlock2Small} onChange={set} /></div>
          </div>
        </div>
      </div>

      {/* SOCIAL MEDIA */}
      <div className="card mb-4">
        <div className="card-header">Social Media URLs</div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4"><input name="InstagramUrl" className="form-control" value={form.InstagramUrl} onChange={set} /></div>
            <div className="col-md-4"><input name="LinkedInUrl" className="form-control" value={form.LinkedInUrl} onChange={set} /></div>
            <div className="col-md-4"><input name="FacebookUrl" className="form-control" value={form.FacebookUrl} onChange={set} /></div>
            <div className="col-md-4"><input name="YouTubeUrl" className="form-control" value={form.YouTubeUrl} onChange={set} /></div>
            <div className="col-md-4"><input name="TikTokUrl" className="form-control" value={form.TikTokUrl} onChange={set} /></div>
          </div>
        </div>
      </div>

      <button onClick={update} className="btn btn-primary btn-lg w-100">Save Changes</button>
    </div>
  );
};

export default FooterEditor;
